import { formatNumberAsCurrency } from '../../../../../../utils';

export const formatCurrency = (val, decimals = 2) => formatNumberAsCurrency(val, '$0', decimals);

export const getReadableNameFromOptions = (options, value) => {
    const option = options.find((op) => op.id === value);
    return option?.name ?? null;
};
